import { z } from "@/zod";
import { ulid, dateTime } from "@/schemas/commonFields";

export const projectSettlementsComment = z.object({
  id: ulid,
  period_id: ulid,
  author_cognito_id: z.string().uuid(),
  user_name: z.string(),
  created_at: dateTime,
  comment: z.string().trim().min(1).max(1000),
});

export const projectSettlementsCommentsRead = projectSettlementsComment
  .omit({
    period_id: true,
    author_cognito_id: true,
  })
  .readonly();

export const projectSettlementsCommentsWrite = projectSettlementsComment.pick({
  comment: true,
});

export type ReadProjectSettlementsComments = z.infer<
  typeof projectSettlementsCommentsRead
>;
export type WriteProjectSettlementsComments = z.infer<
  typeof projectSettlementsCommentsWrite
>;
